import React from "react";
import PropTypes from "prop-types";
import { formatMoney } from "../../components/shared/Utils";

const OrderSummaryItem = ({ item }) => {

    const formattedPrice = formatMoney(item.Amount * item.PricePerUnit);

    return (
        <div>
            <div className="container-fluid product-info-container">
                <div className="row">
                    <div className="col px-0">
                        <div className=" px-0 d-sm-flex w-100">
                            <div className="d-flex w-100 flex-column">
                                <div className="d-flex justify-content-between w-100">
                                    <div className=" pl-0 pr-2">
                                        <a href={undefined}>
                                            <h5 className="product-title"
                                                dangerouslySetInnerHTML={{ __html: item.PartnerPartNumber }}></h5>
                                            {item.ProductNumber && <div className="small-title" dangerouslySetInnerHTML={{ __html: item.ProductNumber }}></div>}
                                            {item.Description && <div className="small-title" dangerouslySetInnerHTML={{ __html: item.Description }}></div>}
                                            {item.OrderCutoffTime && <div className="product-details-text"><span className="label-bold">Order Cutoff:</span>{item.OrderCutoffTime}</div>}
                                            {item.OrderProcessingTime && <div className="product-details-text"><span className="label-bold">Order Processing:</span>{item.OrderProcessingTime}</div>}
                                            {item.ApprovedBy && <div className="product-details-text"><span className="label-bold">Approved By:</span>{item.ApprovedBy}</div>}
                                        </a>
                                    </div>
                                    <div className="px-0 product-price-col">
                                        <div className="d-flex justify-content-end">
                                            <div className="quantity pr-3">Qty:{item.Amount}</div>
                                            <div className="mb-2">
                                                {formattedPrice}
                                            </div>
                                        </div> 
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

OrderSummaryItem.propTypes = {
    item: PropTypes.shape({
        PricePerUnit: PropTypes.number,
        Amount: PropTypes.number,
        PartnerPartNumber: PropTypes.string,
        ProductNumber: PropTypes.string,
        Description: PropTypes.string
    })
}

OrderSummaryItem.defaultProps = {
    item: {
        PricePerUnit: 0,
        Amount: 0,
        PartnerPartNumber: "",
        ProductNumber: "",
        Description: ""
    }
};

export default OrderSummaryItem